import { ExternalDataApiClient } from './api/external_data/ApiClient';
import { GatewaysApiClient, type IGatewaysApiClient } from './api/gateways';
import { EstablishmentsApiClient } from './api/establishments/establishments';
import { FilesApiClient, type IFilesApiClient } from './api/files';
import { SupplyPointsApiClient } from './api/supplyPoints';
import { SupplyPointRevisionsApiClient } from './api/supplyPointRevisions';
import { UserMyConsentsApiClient, UsersApiClient } from './api/users';
import { AnalysisApiClient } from './api/analysis';
import { CustomersApiClient } from './api/customers';
import { AuthApiClient } from './api/auth';
import { EmissionFactorsApiClient, type IEmissionFactorsApiClient } from './api/records/emission_factors';
import { EmissionFactorValiditiesApiClient } from './api/records/emission_factor_validity';
import { EmissionRecordsApiClient } from './api/records/emissions';
import { ToolsApiClient } from './api/tools';
import { SupportApiClient } from './api/support/support';
import { MetersApiClient } from './api/meters/meters';
import { ExportsApiClient } from './api/exports';
import { ManualRecordsApiClient } from './api/records/manual';
import type { INotificationsApiClient } from './api/notifications/types/interface';
import type { INotificationSettingsApiClient } from './api/notification_settings/types/interface';
import { NotificationsApiClient } from './api/notifications/notifications';
import { NotificationSettingsApiClient } from './api/notification_settings/notificationSettings';
import { TenantsApiClient } from './api/tenants';
import { LeaseUnitsApiClient } from './api/lease_units';
import { LeasesApiClient } from './api/leases';
import { RemoteReadingValuesApiClient } from './api/readings/remote/values';
import { FloorPlansApiClient } from './api/floor_plans';
import type { IFloorPlansApiClient } from './api/floor_plans/types/interface';
import { InvoiceRecordsApiClient } from './api/records/invoices';
import { type IUserFavouritesApiClient, UserFavouritesApiClient } from './api/users/favourites';
import { BillingSettingsApiClient } from './api/billing_settings/ApiClient';
import { BillingsApiClient } from './api/billings';
import { RemoteReadingConsumptionApiClient } from './api/readings/remote/consumption/ApiClient';
import { DashboardsApiClient } from './api/dashboard';

export interface Services {
  analysisApiClient: AnalysisApiClient;
  authApiClient: AuthApiClient;
  billingsApiClient: BillingsApiClient;
  billingSettingsApiClient: BillingSettingsApiClient;
  supportApiClient: SupportApiClient;
  customersApiClient: CustomersApiClient;
  dashboardApiClient: DashboardsApiClient;
  emissionFactorApiClient: IEmissionFactorsApiClient;
  emissionFactorValiditiesApiClient: EmissionFactorValiditiesApiClient;
  emissionRecordsApiClient: EmissionRecordsApiClient;
  establishmentsApiClient: EstablishmentsApiClient;
  exportsApiClient: ExportsApiClient;
  externalDataApiClient: ExternalDataApiClient;
  filesApiClient: IFilesApiClient;
  floorPlansApiClient: IFloorPlansApiClient;
  gatewaysApiClient: IGatewaysApiClient;
  invoiceRecordsApiClient: InvoiceRecordsApiClient;
  leasesApiClient: LeasesApiClient;
  leaseUnitsApiClient: LeaseUnitsApiClient;
  manualRecordsApiClient: ManualRecordsApiClient;
  metersApiClient: MetersApiClient;
  notificationsApiClient: INotificationsApiClient;
  notificationSettingsApiClient: INotificationSettingsApiClient;
  remoteReadingValuesApiClient: RemoteReadingValuesApiClient;
  remoteReadingConsumptionApiClient: RemoteReadingConsumptionApiClient;
  supplyPointsApiClient: SupplyPointsApiClient;
  supplyPointRevisionsApiClient: SupplyPointRevisionsApiClient;
  tenantsApiClient: TenantsApiClient;
  toolsApiClient: ToolsApiClient;
  userFavouritesApiClient: IUserFavouritesApiClient;
  userMyConsentsApiClient: UserMyConsentsApiClient;
  usersApiClient: UsersApiClient;
}

export const SERVICES: Readonly<Services> = {
  analysisApiClient: new AnalysisApiClient(),
  authApiClient: new AuthApiClient(),
  billingsApiClient: new BillingsApiClient(),
  billingSettingsApiClient: new BillingSettingsApiClient(),
  supportApiClient: new SupportApiClient(),
  customersApiClient: new CustomersApiClient(),
  dashboardApiClient: new DashboardsApiClient(),
  emissionFactorApiClient: new EmissionFactorsApiClient(),
  emissionFactorValiditiesApiClient: new EmissionFactorValiditiesApiClient(),
  emissionRecordsApiClient: new EmissionRecordsApiClient(),
  establishmentsApiClient: new EstablishmentsApiClient(),
  exportsApiClient: new ExportsApiClient(),
  externalDataApiClient: new ExternalDataApiClient(),
  filesApiClient: new FilesApiClient(),
  floorPlansApiClient: new FloorPlansApiClient(),
  gatewaysApiClient: new GatewaysApiClient(),
  invoiceRecordsApiClient: new InvoiceRecordsApiClient(),
  leasesApiClient: new LeasesApiClient(),
  leaseUnitsApiClient: new LeaseUnitsApiClient(),
  manualRecordsApiClient: new ManualRecordsApiClient(),
  metersApiClient: new MetersApiClient(),
  notificationsApiClient: new NotificationsApiClient(),
  notificationSettingsApiClient: new NotificationSettingsApiClient(),
  remoteReadingValuesApiClient: new RemoteReadingValuesApiClient(),
  remoteReadingConsumptionApiClient: new RemoteReadingConsumptionApiClient(),
  supplyPointsApiClient: new SupplyPointsApiClient(),
  supplyPointRevisionsApiClient: new SupplyPointRevisionsApiClient(),
  tenantsApiClient: new TenantsApiClient(),
  toolsApiClient: new ToolsApiClient(),
  userFavouritesApiClient: new UserFavouritesApiClient(),
  userMyConsentsApiClient: new UserMyConsentsApiClient(),
  usersApiClient: new UsersApiClient(),
} as const;
